const URL_PATERN = /https?:\/\/(www\.)?[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_\+.~#?&//=]*)/gi;

export function safeClear(text: string): string {
  return text.replace(/\>/gim, '&gt')
}

export function wrapLinksInTag (text: string, target = '_blank'): string {
  return text.replace(URL_PATERN, url => `<a href="${encodeURI(url)}" target="${target}">${url}</a>`);
}

export function wrapNewLine(text: string): string {
  return text.replace(/\n/g,'<br>')
}

export function coerce(text: string, funcs: any[]): string {
  let result: string = text
  for (const func of funcs) {
    result = func(result)
  }
  return result;
}